import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";

export interface CardCallToActionBlockProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  highlight?: string;
  styles?: Record<string, StyleValue>;
}

export const CardCallToActionBlock = forwardRef<
  HTMLDivElement,
  CardCallToActionBlockProps
>(({ content, highlight, className, styles, ...rest }, ref) => {
  const { backgroundStyles, paddingStyles, marginStyles, borderColorStyles } =
    useTopBlockStyles({
      styles,
      defaultStyles: primaryBlockDefaultStyles,
    });

  return (
    <div
      style={{
        ...backgroundStyles,
        ...paddingStyles,
        ...marginStyles,
        ...borderColorStyles,
      }}
      ref={ref}
      className={classNames(
        "wb-relative wb-flex wb-flex-col wb-gap-6 wb-rounded-[1.25rem] wb-border wb-p-[1.88rem] wb-h-full wb-bg-primary",
        {
          "wb-border-highlight": highlight,
        },
        className,
      )}
      {...rest}
    >
      {highlight && (
        <div className="wb-absolute wb--top-3.5 wb-left-0 wb-flex wb-w-full wb-items-center wb-justify-center">
          <span className="wb-bg-button-primary wb-text-button-primary-text wb-rounded-full wb-px-4 wb-py-1 wb-text-center wb-text-sm wb-font-semibold wb-uppercase">
            {highlight}
          </span>
        </div>
      )}
      {content}
    </div>
  );
});

CardCallToActionBlock.displayName = "CardCallToActionBlock";
